export class Notification {
  summary: string // message
  detail: string // output
  severity: string // type
  data: CustomErrData
  sticky: boolean // set in frontend
  life: number

  constructor(summary: string, detail: string, severity: string, data: CustomErrData, delayInMS: number) {
    this.summary = summary
    this.detail = detail
    this.severity = severity
    this.data = data
    this.sticky = !delayInMS
    this.life = this.sticky ? undefined : delayInMS
  }
}

export class CustomErrData {
  icon: string // set in frontend
  timeStmp?: string // ts
  stacktrace?: string // trace
  errCode?: number // code

  constructor(icon: string, timeStmp?: string, stacktrace?: string, errCode?: number) {
    this.icon = icon
    this.timeStmp = timeStmp
    this.stacktrace = stacktrace
    this.errCode = errCode
  }
}
